import { cn } from "@/lib/utils"
import { Loader2 } from "lucide-react"

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "default" | "lg" | "xl"
  fullWidth?: boolean
}

const sizeClasses = {
  sm: "h-4 w-4",
  default: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-12 w-12"
}

export function Spinner({ 
  size = "default", 
  fullWidth = true,
  className,
  ...props 
}: SpinnerProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-center",
        fullWidth && "w-full py-6",
        className
      )}
      {...props}
    >
      <Loader2 
        className={cn(
          "animate-spin text-muted-foreground",
          sizeClasses[size]
        )} 
      />
    </div>
  )
} 